function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.65,
  fillRule: "nonzero",
  d: "M9.781 7.906H2.937A.094.094 0 0 0 2.845 8v.656c0 .052.042.094.094.094H9.78a.094.094 0 0 0 .094-.094V8a.094.094 0 0 0-.094-.094zm0-6.656H2.937a.094.094 0 0 0-.093.094V2c0 .052.042.094.094.094H9.78A.094.094 0 0 0 9.875 2v-.656a.094.094 0 0 0-.094-.094zm0 3.328H2.937a.094.094 0 0 0-.093.094v.656c0 .052.042.094.094.094H9.78a.094.094 0 0 0 .094-.094v-.656a.094.094 0 0 0-.094-.094zm-8.25 2.766H.171a.047.047 0 0 0-.046.047v.398c0 .026.021.047.047.047h.848v.24H.602a.047.047 0 0 0-.047.047v.398c0 .026.021.047.047.047h.418v.252H.172a.047.047 0 0 0-.047.047v.399c0 .025.021.046.047.046h1.36a.047.047 0 0 0 .046-.046V7.39a.047.047 0 0 0-.047-.047zm-1.36-6.14h.446v1.405c0 .026.021.047.047.047h.469a.047.047 0 0 0 .047-.047V.781a.094.094 0 0 0-.094-.094H.172a.047.047 0 0 0-.047.047v.422c0 .026.021.047.047.047zm1.36 2.812H.171a.047.047 0 0 0-.046.046v.422c0 .026.021.047.047.047h.801l-.823.91a.097.097 0 0 0-.025.064v.433c0 .025.021.046.047.046h1.36a.047.047 0 0 0 .046-.046v-.422a.047.047 0 0 0-.047-.047H.73l.824-.91a.097.097 0 0 0 .024-.064v-.433a.047.047 0 0 0-.047-.046z"
});

var SvgOrderedList = function SvgOrderedList(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOrderedList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ordered-list.0a60cf6b.svg";
export { ForwardRef as ReactComponent };